module.exports = __webpack_public_path__ + "img/nccc.78d32cd4.jpg";